/**
 * i18n nhập khẩu số dư tạm ứng đầu kỳ
 * nnninh 10/05/2023
 */
export default {
  // popup cha
  ImportExcel: {
    Text: {
      InsertInformation: 'Nhập dữ liệu',
      Continue: 'Tiếp tục',
      SelectSourceFile: 'Chọn tệp nguồn',
      CheckData: 'Kiểm tra dữ liệu',
      Result: 'Kết quả',
      MatchColumns: 'Ghép dữ liệu',
    },
  },
  ImportStepFirst: {
    Text: {
      Import: 'Nhập khẩu',
      OrImportFile: ' hoặc kéo thả tệp nhập khẩu vào đây',
      SupportImport: ' Hỗ trợ nhập khẩu tệp định dạng Excel, dung lượng tối đa 5MB',
      DownLoadFileSample: 'Tải tệp mẫu',
      SheetData: 'Sheet chứa dữ liệu *',
      MethodInsert: 'Phương thức nhập:',
      StepNotesAdd: 'Thêm mới',
      StepNotesUpdate: 'Cập nhật',
      StepNotesOverride: 'Ghi đè',
      TextStepNotesAdd: 'Trên hệ thống dữ liệu chưa có sẽ được thêm mới, dữ liệu đã có sẽ không được cập nhật.',
      TextStepNotesUpdate: 'Trên hệ thống dữ liệu chưa có sẽ được thêm mới, dữ liệu đã có sẽ được cập nhật.',
      TextStepNotesOverride: 'Toàn bộ dữ liệu trong hệ thống sẽ được thay thế bằng dữ liệu trong tệp nhật khẩu.',
    },
  },
  // Bước 2
  ImportStepThird: {
    Text: {
      ValidRecord: 'bản ghi hợp lệ',
      NotValidRecord: 'bản ghi không hợp lệ',
      DownloadFileCheck: 'Tải tệp kiểm tra',
    },
  },
  // Bước 3
  ImportStepFour: {
    Text: {
      ResultText: 'Kết quả nhập khẩu',
      RecordSuccess: 'bản ghi nhập khẩu thành công',
      RecordNotSuccess: 'bản ghi nhập khẩu không thành công',
      DownloadFileError: 'Tải tệp lỗi',
    },
  },
};
